<template>
  <office-dashboard
    v-if="['Office', 'Project Manager'].includes(this.user.role)"
  />
  <v-container grid-list-lg v-else>
    <v-layout justify-left row>
      <v-flex xs12 class="px-4 mb-0 pb-0">
        <!-- <v-alert outlined type="info" text class="mb-0">
          <strong class="mr-2">TOOL INVENTORY!</strong> Check your tool
          inventory on the app. Click on the "Tools On Site" link on the left.
        </v-alert> -->
      </v-flex>

      <v-flex xs12 sm6 v-for="card in homeCards" :key="card.title">
        <v-card elevation="5" class="ma-2" height="100%">
          <v-img
            :src="card.img"
            height="120"
            gradient="to bottom, rgba(22, 55, 88, 1) , rgba(22, 55, 88,.7)"
          >
            <v-card-title class="white--text display-1 font-weight-regular">{{
              card.title
            }}</v-card-title>
          </v-img>

          <v-card-subtitle class="pb-0">{{ card.subtitle }}</v-card-subtitle>
          <v-card-text class="text--primary">
            <div>{{ card.description }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" :to="card.path" :disabled="card.disabled">
              <v-icon left small>{{ card.icon }}</v-icon>
              {{ card.button }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OfficeDashboard from "../components/dashboard/OfficeDashboard";
import { mapState } from "vuex";
export default {
  components: {
    OfficeDashboard,
  },
  data: () => ({
    homeCards: [
      {
        title: "Punch In/Out",
        img:
          "https://firebasestorage.googleapis.com/v0/b/alba-demolition.appspot.com/o/images%2Ftool-ordering.jpg?alt=media&token=ed00fdd2-1258-41a9-b687-255033190d86",
        description: "Punch in and out.",
        icon: "clock",
        button: "Punch In/Out ",
        subtitle: "",
        path: "/punch-dashboard",
        disabled: false,
      },
      {
        title: "Order Tools",
        img:
          "https://firebasestorage.googleapis.com/v0/b/alba-demolition.appspot.com/o/images%2Ftool-ordering.jpg?alt=media&token=ed00fdd2-1258-41a9-b687-255033190d86",
        description:
          "Get notified when tool orders are ready and the tool quantities that will be delivered. Track orders all the way through to returns.",
        icon: "build",
        button: "Order Tools",
        subtitle: "Easily place tool orders.",
        path: "/tools/order",
        disabled: false,
      },
      {
        title: "Tool Pickups",
        img:
          "https://firebasestorage.googleapis.com/v0/b/alba-demolition.appspot.com/o/images%2Ftruck-requests.jpg?alt=media&token=090a58fe-bf31-4762-9304-690b8a6ac045",
        description:
          "The Yard will be notified once you submit your request. The yard will also confirm once they receive the tools.",
        icon: "local_shipping",
        button: "Request a Tool Pickup",
        subtitle: "Quickly request pickups",
        path: "/tools/pickup-request",
        disabled: false,
      },
      {
        title: "Tools On Site",
        img:
          "https://firebasestorage.googleapis.com/v0/b/alba-demolition.appspot.com/o/images%2Ftruck-requests.jpg?alt=media&token=090a58fe-bf31-4762-9304-690b8a6ac045",
        description:
          "Find out which tools are on site. Select the job site and see the inventory at that site.",
        icon: "build",
        button: "Tools on site",
        subtitle: "Check your inventory.",
        path: "/tools/tools-on-site",
        disabled: false,
      },
    ],
  }),
  computed: {
    ...mapState(["user"]),
  },
};
</script>

<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
